<template>
 <div class="section">
   <loading-block v-if="is_load==false" :loading="!is_load"/>
   <div   class="" v-if="is_load"   >
     <div class="container" >
       <div class="row mt-3">
         <div class="col-md-4 col-12 service_image_block img_div">
           <img :src="image_url+lead.category.image" class=" img-thumbnail col-12" :alt="lead.category.name">
           <br>

         </div>
         <div class="col-md-8 col-12  mini_service_div">
           <h2 class="text-center " >{{ lead.category.name}}</h2>

           <editorjsrender v-if="lead.category.content_json && lead.category.content_json.blocks"  :blocks_json="lead.category.content_json.blocks" :isshort="true"></editorjsrender>





         </div>
       </div>


     </div>

   </div>

   <section class="section section-shaped section-lg  my-0" v-if="is_load" style="">

     <div class="container " v-if="is_load" >

       <div class="row mt-3">

         <div class="col-lg-12 card p-3">
           <h2 class="text-megablue">Подтверждение начало работы</h2>

           <editorjsrender class="ml-3" v-if="is_load " :blocks_json="lead.project_data.blocks"></editorjsrender>



         </div>

         <div class="col-lg-12 card mt-2 pt-2">
           <p v-if="islogin==false">Для продолжения работы, вам необходимо авторизоваться через Telegram</p>
           <p v-if="islogin==true">Для продолжения работы, вам необходимо подтвердить создание проекта.</p>



           <button class="btn m-2" v-if="islogin==false" @click="callModalLogin">
             Для продолжения необходимо авторизоваться
           </button>
           <button   class="btn m-2" v-if="islogin==true && is_show_btn" @click="confirmProject">
             Подтвердить<br> создание проекта
           </button>
         </div>




       </div>
       <div class="row" v-if="islogin && lead.developer_id==null && !(lead.sum && lead.sum>0)">
        <div class="col-12">
          <p>После подтверждения проекта, ваш проект уйдет на оценку исполнителям</p>
        </div>
       </div>
       <div class="row" v-if="islogin && lead.developer && !(lead.sum && lead.sum>0)">
         <div class="col-12 alert alert-success">
           <p>После подтверждения проекта, вашим исполнителем будет <router-link tag="a" :to="{name: 'user_page_main', params: { user_id: lead.developer.last_id }}" class=" btn">
             {{ lead.developer.name}}</router-link></p>
          </div>
       </div>
       <div class="row" v-if="islogin && lead.sum && lead.sum>0">
         <div class="col-12 alert alert-success" v-if="lead.type_invoice=='every_month'">
           <p>После подтверждения проекта, будет создан счет на сумму {{ lead.sum }} {{ lead.currency}} с оплатой каждый месяц</p>
         </div>
         <div class="col-12 alert alert-success" v-if="lead.type_invoice=='every_year'">
           <p>После подтверждения проекта, будет создан счет на сумму {{ lead.sum }} {{ lead.currency}} с оплатой каждый год</p>
         </div>
         <div class="col-12 alert alert-success" v-if="lead.type_invoice=='one'">
           <p>После подтверждения проекта, будет создан счет на сумму {{ lead.sum }} {{ lead.currency}}</p>
         </div>
       </div>

     </div>
   </section>
<!--   <section class="section section-lg " v-if="is_load">-->
<!--     <div class="container">-->




<!--       <div class="  row row-grid align-items-center"     >-->
<!--         <div class="col-md-6 order-md-2">-->
<!--           <img src="/img/features/list_proj.jpg" class="img-fluid floating">-->
<!--         </div>-->
<!--         <div class="col-md-6 order-md-1">-->
<!--           <h2 class="text-white">Постоянный доступ к проекту</h2>-->
<!--           <div class="pr-md-5" >-->
<!--            <p class="text-white">После подтверждения создания проекта, у вас будет постоянный доступ в систему где вы сможете контролировать ход ведения проекта</p>-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
<!--   </section>-->

<!--   <section class="section section-lg " v-if="is_load">-->
<!--     <div class="container">-->




<!--       <div class="  row row-grid align-items-center"     >-->
<!--         <div class="col-md-6 order-md-2">-->
<!--           <img src="/img/features/canban.jpg" class="img-fluid floating">-->
<!--         </div>-->
<!--         <div class="col-md-6 order-md-1">-->
<!--           <h2>Умная Канбан-доска</h2>-->
<!--           <div class="pr-md-5" >-->
<!--             <p>После подтверждения создания проекта, вы сможете видеть прогресс по работе над вашим проектом с помощью умной канбан-доски, которая будет сохранять последние ваши фильтры.</p>-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
<!--   </section>-->
<!--   <section class="section section-lg " v-if="is_load">-->
<!--   <div class="container">-->




<!--     <div class="  row row-grid align-items-center"     >-->
<!--       <div class="col-md-6 order-md-2">-->
<!--         <img src="/img/features/post.jpg" class="img-fluid floating">-->
<!--       </div>-->
<!--       <div class="col-md-6 order-md-1">-->
<!--         <h2 class="text-white">База знаний</h2>-->
<!--         <div class="pr-md-5" >-->
<!--           <p class="text-white">После подтверждения создания проекта, у вашего проекта будет база знаний, где разработчик сможет размещать инструкции для пользователя. А также критически важную для вашего проекта информацию</p>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
<!--   </div>-->
<!--   </section>-->
<!--   <div class="section section-lg " v-if="is_load">-->
<!--     <div class="container">-->




<!--       <div class="  row row-grid align-items-center"     >-->
<!--         <div class="col-md-6 order-md-2">-->
<!--           <img src="/img/features/addtask.jpg" class="img-fluid floating">-->
<!--         </div>-->
<!--         <div class="col-md-6 order-md-1">-->
<!--           <h2>Поддержка</h2>-->
<!--           <div class="pr-md-5" >-->
<!--             <p>По завершению проекта, у вас всегда останется доступ в систему для того чтобы вы могли добавить задачу на будущие доработки вашего проекта</p>-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
<!--   </div>-->
 </div>
  <!-- 1st Hero Variation -->


</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "@/models/Api";
import Modal from "@/components/Modal";
import vueKanban from 'vue-kanban'
import itemTemplate from '@/components/itemTemplate.vue';
import Editorjsrender from "@/models/Editorjsrender";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "confirm",

  data() {

    var app = this;

    return {
      "user":null,
      "is_load":false,
      "is_show_btn":true,
      "islogin":false,
      "lead":null,
      "image_url":null,
      'background_image':'',
      'title_site':'',



    }
  },

  mounted: function () {

    var app = this;
    app.image_url = Vue.config.IMAGE_URL;

    let id = app.$route.params.id;
    Api.loadOrder(id,function(data){
      app.lead=data.lead;
      app.is_load=true;
      if(data.about.image){
        app.background_image=app.image_url+data.about.image;
      }
      if(data.about.title){
        app.title_site=data.about.title;
      }

    })

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;
          if (!(window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData)) {
            document.location.reload();
          }


        }
      }


    });








  },
  methods: {
    confirmProject(){
      var id=this.lead.secretId;
      var app=this;
      app.is_show_btn=false;
      Api.confirmOrder(id,function(data){
        if(data && data.invoice_id){
          app.$router.push({name: 'invoice', params: { "id": data.invoice_id }});
        }else {
          app.$router.push({name: 'home', params: { "rand": Math.random()}});
        }

      })
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },



  },
  components: {Modal,'editorjsrender': Editorjsrender,LoadingBlock}
};
</script>